import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CategoryProps} from '../types';
import categoriesKeys from '../util/categories-keys';

export interface EditCategoryProps extends Omit<CategoryProps, 'id'> {}

const useEditCategory = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: CategoryProps) => {
    update(categoriesKeys.list(), data);
    setData(categoriesKeys.details(id), data);
  };

  return useApiMutation<EditCategoryProps>({
    url: `/categories/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar categoria',
    successTitle: 'Editar categoria',
    successMessage: 'Categoria atualizada com sucesso',
    onSuccess,
  });
};

export default useEditCategory;
